import { Customer, User, WorkOrder } from './types'

export const mockUsers: User[] = [
  {
    id: 'u1',
    full_name: 'Luka Cigale',
    email: 'luka@podjetje.si',
    role: 'Admin',
    sso_provider: 'Microsoft',
    is_active: true,
    created_at: '2023-01-10T08:00:00Z',
    updated_at: '2023-01-10T08:00:00Z',
  },
  {
    id: 'u2',
    full_name: 'Ana Novak',
    email: 'ana@podjetje.si',
    role: 'Office',
    sso_provider: 'Microsoft',
    is_active: true,
    created_at: '2023-02-15T09:30:00Z',
    updated_at: '2023-02-15T09:30:00Z',
  },
  {
    id: 'u3',
    full_name: 'Marko Horvat',
    email: 'marko@podjetje.si',
    role: 'Technician',
    sso_provider: 'Google',
    is_active: true,
    created_at: '2023-03-20T10:15:00Z',
    updated_at: '2023-03-20T10:15:00Z',
  },
  {
    id: 'u4',
    full_name: 'Petra Zupan',
    email: 'petra@podjetje.si',
    role: 'Technician',
    sso_provider: 'Google',
    is_active: true,
    created_at: '2023-04-05T11:45:00Z',
    updated_at: '2023-04-05T11:45:00Z',
  },
]

export const mockCustomers: Customer[] = [
  {
    id: 'c1',
    name: 'Telekom Slovenije d.d.',
    prefix: 'TS',
    sequence_start: 1,
    address: 'Cigaletova ulica 15',
    postal_code: '1000',
    city: 'Ljubljana',
    tax_number: 'SI98765432',
    contact_person: 'Janez Kranjc',
    email: 'janez.kranjc@telekom.si',
    phone: '01 234 5678',
    notes: 'Ključna stranka, VIP podpora.',
    is_active: true,
    created_at: '2023-01-05T08:00:00Z',
    updated_at: '2023-01-05T08:00:00Z',
  },
  {
    id: 'c2',
    name: 'Petrol d.d.',
    prefix: 'PT',
    sequence_start: 1,
    address: 'Dunajska cesta 50',
    postal_code: '1000',
    city: 'Ljubljana',
    tax_number: 'SI12345678',
    contact_person: 'Maja Kovač',
    email: 'maja.kovac@petrol.si',
    phone: '01 987 6543',
    notes: '',
    is_active: true,
    created_at: '2023-02-10T09:00:00Z',
    updated_at: '2023-02-10T09:00:00Z',
  },
  {
    id: 'c3',
    name: 'Krka d.d.',
    prefix: 'KR',
    sequence_start: 1,
    address: 'Šmarješka cesta 6',
    postal_code: '8501',
    city: 'Novo mesto',
    tax_number: 'SI11223344',
    contact_person: 'Tone Vidmar',
    email: 'tone.vidmar@krka.si',
    phone: '07 331 2111',
    notes: 'Dostop samo z najavo.',
    is_active: true,
    created_at: '2023-03-15T10:00:00Z',
    updated_at: '2023-03-15T10:00:00Z',
  },
  {
    id: 'c4',
    name: 'Mercator d.d.',
    prefix: 'MC',
    sequence_start: 1,
    address: 'Dunajska cesta 107',
    postal_code: '1000',
    city: 'Ljubljana',
    tax_number: 'SI44332211',
    contact_person: 'Vesna Mlakar',
    email: 'vesna.mlakar@mercator.si',
    phone: '01 560 1000',
    notes: '',
    is_active: true,
    created_at: '2023-04-20T11:00:00Z',
    updated_at: '2023-04-20T11:00:00Z',
  },
]

export const mockWorkOrders: WorkOrder[] = [
  {
    id: 'wo1',
    customer_id: 'c1',
    work_order_number: 'TS-24-001',
    sequence_number: 1,
    year: 24,
    execution_date: '2024-05-10',
    location: 'Ljubljana Center, centrala',
    customer_reference_or_orderer: 'Naročil: J. Kranjc',
    urgency: 'Redno',
    status: 'Zaključeno',
    assigned_user_id: 'u3',
    work_description: 'Redni pregled in vzdrževanje UPS sistemov.',
    notes: 'Vse deluje brezhibno.',
    technician_name: 'Marko Horvat',
    orderer_name: 'Janez Kranjc',
    pdf_url: '',
    created_by: 'u2',
    updated_by: 'u3',
    created_at: '2024-05-08T08:00:00Z',
    updated_at: '2024-05-10T15:00:00Z',
    labor_items: [
      {
        id: 'l1',
        work_order_id: 'wo1',
        sort_order: 1,
        description: 'Pregled UPS',
        quantity: 2,
        unit: 'h',
      },
      {
        id: 'l2',
        work_order_id: 'wo1',
        sort_order: 2,
        description: 'Čiščenje filtrov',
        quantity: 1,
        unit: 'h',
      },
    ],
    material_items: [
      {
        id: 'm1',
        work_order_id: 'wo1',
        sort_order: 1,
        material_name: 'Zračni filter',
        quantity: 4,
        unit: 'kos',
      },
    ],
  },
  {
    id: 'wo2',
    customer_id: 'c2',
    work_order_number: 'PT-24-001',
    sequence_number: 1,
    year: 24,
    execution_date: '2024-05-12',
    location: 'BS Celje',
    customer_reference_or_orderer: 'Naročil: M. Kovač',
    urgency: 'Nujno',
    status: 'V delu',
    assigned_user_id: 'u4',
    work_description: 'Popravilo avtomatskih vrat na bencinskem servisu.',
    notes: 'Vrata se zatikajo pri zapiranju.',
    technician_name: 'Petra Zupan',
    orderer_name: 'Maja Kovač',
    pdf_url: '',
    created_by: 'u2',
    updated_by: 'u4',
    created_at: '2024-05-11T09:00:00Z',
    updated_at: '2024-05-12T10:00:00Z',
    labor_items: [
      {
        id: 'l3',
        work_order_id: 'wo2',
        sort_order: 1,
        description: 'Diagnostika napake',
        quantity: 1,
        unit: 'h',
      },
    ],
    material_items: [],
  },
  {
    id: 'wo3',
    customer_id: 'c3',
    work_order_number: 'KR-24-001',
    sequence_number: 1,
    year: 24,
    execution_date: '2024-05-15',
    location: 'Obrat 2, Novo mesto',
    customer_reference_or_orderer: 'Naročil: T. Vidmar',
    urgency: 'Kritično',
    status: 'Osnutek',
    assigned_user_id: 'u3',
    work_description: 'Zamenjava senzorjev temperature v proizvodnji.',
    notes: 'Potrebna zaščitna oprema.',
    technician_name: '',
    orderer_name: '',
    pdf_url: '',
    created_by: 'u1',
    updated_by: 'u1',
    created_at: '2024-05-14T14:00:00Z',
    updated_at: '2024-05-14T14:00:00Z',
    labor_items: [],
    material_items: [],
  },
  {
    id: 'wo4',
    customer_id: 'c1',
    work_order_number: 'TS-24-002',
    sequence_number: 2,
    year: 24,
    execution_date: '2024-05-20',
    location: 'V78 LJ + P17 NM',
    customer_reference_or_orderer: 'Amos Levec',
    urgency: 'Redno',
    status: 'V delu',
    assigned_user_id: 'u3',
    work_description: 'Popravilo zapornic in menjava senzorjev.',
    notes: '',
    technician_name: 'Luka Cigale',
    orderer_name: 'Amos Levec',
    pdf_url: '',
    created_by: 'u1',
    updated_by: 'u1',
    created_at: '2024-05-18T10:00:00Z',
    updated_at: '2024-05-18T10:00:00Z',
    labor_items: [
      {
        id: 'l4',
        work_order_id: 'wo4',
        sort_order: 1,
        description: 'Popravilo zapornic',
        quantity: 2,
        unit: 'h',
      },
    ],
    material_items: [
      {
        id: 'm2',
        work_order_id: 'wo4',
        sort_order: 1,
        material_name: 'Set za popravilo zapornic CAME GARD PX',
        quantity: 2,
        unit: 'kos',
      },
    ],
  },
]
